export const breakpoints = {
  l: "1800px",
  m: "1200px",
  s: "900px",
  xs: "400px",
};
